import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Countdown = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <path
      fill={props.color || theme.palette.grey600}
      d="M20 8.333V20l-8.25 8.25A11.63 11.63 0 0020 31.667c6.443 0 11.667-5.224 11.667-11.667S26.443 8.333 20 8.333zM20 0C8.955 0 0 8.955 0 20s8.955 20 20 20 20-8.955 20-20S31.047 0 20 0zm0 35c-8.283 0-15-6.717-15-15 0-8.285 6.717-15 15-15 8.285 0 15 6.715 15 15 0 8.283-6.715 15-15 15z"
    ></path>
  </svg>
);
